
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("widget/user-picker",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " <img class=\"fw-avatar fw-avatar-sizeM fw-background-branded\" src=\"images/logo.png\" title=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"messages.toAll",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":232},"end":{"line":1,"column":259}}})) != null ? stack1 : "")
    + "\"><span style=\"height:30px;width:1px;background-color:#ccc;display:inline-block;vertical-align:middle;margin:0 4px\"></span> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"members") || (depth0 != null ? lookupProperty(depth0,"members") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"members","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":383},"end":{"line":1,"column":519}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"members")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <img class=\"fw-avatar fw-avatar-sizeM\" src=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"thumb") : depth0), depth0))
    + "\" title=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\" data-accountId=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"accountId") : depth0), depth0))
    + "\"/> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  "<select name=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"selectName") : depth0), depth0))
    + "\" style=\"display:none\" multiple=\"multiple\"></select><p style=\"line-height:40px\" class=\"selectable\"> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"family") || (depth0 != null ? lookupProperty(depth0,"family") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"family","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":130},"end":{"line":1,"column":531}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"family")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " </p>";
},"useData":true});
export default TPL;